import script from "./Tenant.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tenant.vue?vue&type=script&lang=ts&setup=true"

import "./Tenant.vue?vue&type=style&index=0&id=43e66d84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e66d84"]])

export default __exports__